import {Button} from '@material-ui/core';
import {AppCtx} from 'context/AppContext';
import {UserContext} from 'context/UserContext';
import {useGetCreditSaveCardToken} from 'hooks/useGetEndpoint';
import {useContext, useEffect, useState} from 'react';

const saveMethod = {method: 'modal'};

const CreditSaveCardModal = ({
    open,
    setReady = () => {},
    setPaymentToken = () => {},
    setTransactionStatus = () => {},
    saveToContext = false,
}) => {
    const {data: gravityToken} = useGetCreditSaveCardToken(saveMethod);
    const {config} = useContext(AppCtx);
    const [assetsLoaded, setAssetsLoaded] = useState(false);
    const {actions} = useContext(UserContext);

    const openModal = () => {
        window.emergepay?.open({
            transactionToken: gravityToken?.transactionToken,
            onTransactionSuccess: approvalData => {
                setTransactionStatus('success');
                setPaymentToken(approvalData);
                saveToContext && actions.updatePayment(approvalData);
                window.emergepay?.close();
            },
            onTransactionFailure: failureData => {
                setTransactionStatus('error');
                console.debug('failureData', failureData);
            },
            onTransactionCancel: () => {
                setTransactionStatus('canceled');
            },
        });
    };

    useEffect(() => {
        const script = document.createElement('script');
        script.src =
            config.emergepayHostedModalSrc ||
            'https://assets.emergepay-sandbox.chargeitpro.com/cip-hosted-modal.js';
        script.onload = () => {
            setAssetsLoaded(true);
        };
        document.head.appendChild(script);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (assetsLoaded && gravityToken && window.emergepay) {
            // not necessary, but supposed to reduce load time
            window.emergepay?.init();
            // this is necessary in order to make sure user doesn't attempt
            // to open modal before we have a gravity token
            setReady(true);
        }
        // eslint-disable-next-line
    }, [assetsLoaded, gravityToken, window.emergepay]);

    useEffect(() => {
        // only try to open if we have both the scrip and a gravity token
        if (open && assetsLoaded && gravityToken) {
            openModal();
        }
        // eslint-disable-next-line
    }, [open]);

    return null;
};

// example of how to use the CreditSaveCardModal with external trigger
const CreditSaveCardModalButton = ({
    setPaymentToken,
    buttonText = 'Update Card',
    saveToContext = false,
    ...buttonProps
}) => {
    const [modalOpen, setModalOpen] = useState(false);
    const [ready, setReady] = useState(false);
    const [transactionStatus, setTransactionStatus] = useState(null);
    const [reset, setReset] = useState(false);

    // reset payment modal
    useEffect(() => {
        if (['canceled', 'error', 'success'].includes(transactionStatus)) {
            setTransactionStatus(null);
            setReady(false);
            setModalOpen(false);
            setReset(true);
        }
    }, [transactionStatus]);

    // cheap way to reinitialize (remove and re-add) the hosted fields
    useEffect(() => {
        if (reset) {
            setReset(false);
        }
    }, [reset]);

    return (
        <Button
            variant='contained'
            onClick={() => {
                setTransactionStatus('inProgress');
                setModalOpen(true);
            }}
            disabled={!ready || transactionStatus === 'inProgress'}
            {...buttonProps}
        >
            {buttonText}
            {!reset && (
                <CreditSaveCardModal
                    open={modalOpen}
                    setReady={setReady}
                    setPaymentToken={setPaymentToken}
                    setTransactionStatus={setTransactionStatus}
                    saveToContext={saveToContext}
                />
            )}
        </Button>
    );
};

export default CreditSaveCardModal;
export {CreditSaveCardModalButton};
